export default class TipoDocumentoEnum {
  static get Outros() {
    return 0;
  }

  static get CTe() {
    return 1;
  }

  static get MDFe() {
    return 2;
  }

  static get CFe() {
    return 3;
  }

  static get ContratoDeTransporte() {
    return 4;
  }

  static get TermoDeEstadia() {
    return 5;
  }

  static get OrdemDeCarregamento() {
    return 6;
  }

  static get CartaDeCorrecao() {
    return 7;
  }

  static get TicketDePesagem() {
    return 8;
  }

  static get Checklist() {
    return 9;
  }

  static get LoudoDeClassificacao() {
    return 10;
  }

  static get NFe() {
    return 11;
  }

  static get CartaFrete() {
    return 12;
  }

  static get NFSe() {
    return 13;
  }

  static get ComprovanteDeDescarga() {
    return 14;
  }
}
